// extracted by mini-css-extract-plugin
module.exports = {"r1o1bbkb":"r1o1bbkb","c15cr4p7":"c15cr4p7","icon":"icon"};